import { render } from "./PasswordInput.vue?vue&type=template&id=4e7af644"
import script from "./PasswordInput.vue?vue&type=script&lang=js"
export * from "./PasswordInput.vue?vue&type=script&lang=js"
script.render = render

export default script